// jshint esversion: 8

export default {
  SET_ID: (state, id) => state.id = id,
  SET_LOCATION: (state, location) => state.location = location,
  SET_NAME: (state, name) => state.name = name,
  SET_OPERATOR: (state, operator) => state.operator = operator
}
